import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=2875b645"
import script from "./Line.vue?vue&type=script&lang=js"
export * from "./Line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports